<template>
    <div class="databox-warp">
        <div class="title"><img src="./images/icon06.png" /> 数据记录</div>
        <div class="data_con" id="databox"></div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';

export default {
    name:"databox",
    data(){
        return {
            msgCnt:[{msg:100,alm:20},
                {msg:200,alm:40},
                {msg:300,alm:50},
                {msg:400,alm:35},
                {msg:400,alm:40},
                {msg:400,alm:11},
                {msg:400,alm:66},
                {msg:100,alm:77},
                {msg:200,alm:88},
                {msg:300,alm:22},
                {msg:400,alm:99},
                {msg:400,alm:100},
                {msg:400,alm:111},
                {msg:400,alm:222},
                {msg:100,alm:333},
                {msg:200,alm:11},
                {msg:300,alm:33},
                {msg:400,alm:55},
                {msg:400,alm:77},
                {msg:400,alm:90}
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        // 初始化
        init(){
            var dom = document.getElementById("databox");
            var myChart = echarts.init(dom);
            let option = null;
            // Generate data
            var category = [];
            var dottedBase = +new Date();
            dottedBase-=3600 * 24 * 1000*20;
            var lineData = [];
            var barData = [];

            for (var i = 0; i < 20; i++) {
                var date = new Date(dottedBase += 3600 * 24 * 1000);
                category.push([
                    date.getFullYear(),
                    date.getMonth() + 1,
                    date.getDate()
                ].join('-'));
                var b = this.msgCnt[i].msg;
                var d = this.msgCnt[i].alm;
                barData.push(b)
                lineData.push(d + b);
            }


            // option
            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['处理数', '报警数'],
                    textStyle: {
                        color: '#ccc'
                    }
                },
                xAxis: {
                    data: category,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    }
                },
                yAxis: {
                    splitLine: {show: false},
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    }
                },
                series: [{
                    name: 'line',
                    type: 'line',
                    smooth: true,
                    showAllSymbol: true,
                    symbol: 'emptyCircle',
                    symbolSize: 15,
                    data: lineData
                }, {
                    name: '报警数',
                    type: 'bar',
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 5,
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: '#14c8d4'},
                                    {offset: 1, color: '#43eec6'}
                                ]
                            )
                        }
                    },
                    data: barData
                }, {
                    name: '处理数',
                    type: 'bar',
                    barGap: '-100%',
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgba(20,200,212,0.5)'},
                                    {offset: 0.2, color: 'rgba(20,200,212,0.2)'},
                                    {offset: 1, color: 'rgba(20,200,212,0)'}
                                ]
                            )
                        }
                    },
                    z: -12,
                    data: lineData
                }, {
                    name: 'dotted',
                    type: 'pictorialBar',
                    symbol: 'rect',
                    itemStyle: {
                        normal: {
                            color: '#0f375f'
                        }
                    },
                    symbolRepeat: true,
                    symbolSize: [12, 4],
                    symbolMargin: 1,
                    z: -10,
                    data: lineData
                }]
            }
            if (option && typeof option === "object") {
                myChart.setOption(option, true);
            }
        }
    }
}
</script>
<style lang="scss">
.databox-warp{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .data_con{
        flex: 1;
    }
}
</style>